import { useEffect, useState } from 'react';

export default function usePrerender() {
  const [isPrerender, setIsPrerender] = useState(
    navigator?.userAgent.includes('Prerender')
  );

  useEffect(() => {
    if (navigator?.userAgent.includes('Prerender')) {
      setIsPrerender(true);
    } else {
      setIsPrerender(false);
    }
  }, [setIsPrerender]);

  return { isPrerender };
}
